/**
 * Toggle Display on click
 * @module toggleDisplay
 */

import $ from 'jquery';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'toggleDisplay';
export const CLICK_HANDLER = 'click';
export const CHANGE_HANDLER = 'change';
export const DEFAULTS = {};


/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

 const toggler = ($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options) => {
   if( ANIMATION_TYPE === "pop" ) {
     $(TOGGLE_SHOW).show();
     $(TOGGLE_HIDE).hide();
   } else {
     $(TOGGLE_SHOW).slideDown();
     $(TOGGLE_HIDE).slideUp();
   }
 };

 const selfToggler = ($el, TOGGLE_THIS, ANIMATION_TYPE, options) => {
  if( ANIMATION_TYPE === "slide" ) {
    if($el.hasClass("is-active")) {
        $(TOGGLE_THIS).slideUp();
        $el.removeClass("is-active");
    } else {
        $(TOGGLE_THIS).slideDown();
        $el.addClass("is-active");
    }
  } else {
    if($el.hasClass("is-active")) {
        $(TOGGLE_THIS).hide();
        $el.removeClass("is-active");
    } else {
        $(TOGGLE_THIS).show();
        $el.addClass("is-active");
    }
  }
 }

 const setEventListeners = ($el, TOGGLE_THIS, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options) => {
   $el.on(CLICK_HANDLER, evt => {
     toggler($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options);
     selfToggler($el, TOGGLE_THIS, ANIMATION_TYPE, options)
   });
   $el.on(CHANGE_HANDLER, () => {
    const selectedOption = $el.find(':selected');
    const $showElements = $(selectedOption.attr('data-toggle-select-show'));
    const $hideElements = $(selectedOption.attr('data-toggle-select-hide'));
    const $animationType = selectedOption.attr('data-toggle-select-animation');
    if($showElements && $hideElements) {
      toggler(selectedOption, $showElements, $hideElements, $animationType, options);
    }
  });
 };


/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function toggleDisplay(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const TOGGLE_SHOW = $el.data("toggle-select-show");
  const TOGGLE_HIDE = $el.data('toggle-select-hide');
  const TOGGLE_THIS = $el.data('toggle-select-this');
  const ANIMATION_TYPE = $el.data('toggle-select-animation');
  setEventListeners($el, TOGGLE_THIS, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options);
}
registerJQueryPlugin(PLUGIN_NAME, toggleDisplay);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-display.js